// src/serviceWorkerRegistration.js
let deferredPrompt;

export const register = (config = {}) => {
  if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
    window.addEventListener('load', async () => {
      try {
        const reg = await navigator.serviceWorker.register('/service-worker.js', { scope: '/' });
        console.log('[SW] Registered with scope:', reg.scope);

        // Force check for updates immediately and periodically
        reg.update();

        // Listen for updates and handle waiting state
        reg.addEventListener('updatefound', () => {
          const installingWorker = reg.installing;
          if (installingWorker == null) return;

          installingWorker.addEventListener('statechange', () => {
            if (installingWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // New SW is waiting — tell it to activate immediately
              installingWorker.postMessage({ type: 'SKIP_WAITING' });

              // Optional: Listen for activation and force reload to apply changes
              installingWorker.addEventListener('statechange', (e) => {
                if (e.target.state === 'activated') {
                  console.log('[SW] New version activated — reloading page');
                  window.location.reload();  // This ensures fresh state after activation
                }
              });
            }
          });
        });

        // If there's already a waiting SW on registration (edge case)
        if (reg.waiting) {
          reg.waiting.postMessage({ type: 'SKIP_WAITING' });
          window.location.reload();  // Reload to apply waiting SW
        }

        if (config.onSuccess) config.onSuccess(reg);
      } catch (err) {
        console.error('[SW] Registration failed', err);
        if (config.onError) config.onError(err);
      }

      // Periodic update check
      navigator.serviceWorker.ready.then((r) => r.update());
    });

    // Global message listener for SKIP_WAITING confirmation (safety net)
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data && event.data.type === 'SKIP_WAITING') {
        // Optional: reload here too if needed
        window.location.reload();
      }
    });
  }
};

export const captureInstallPrompt = (cb) => {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredPrompt = e;
    cb?.(e);
  });
  window.addEventListener('appinstalled', () => {
    console.log('SErraND app installed');
    deferredPrompt = null;
  });
};

export const triggerInstallPrompt = async () => {
  if (!deferredPrompt) return;
  deferredPrompt.prompt();
  await deferredPrompt.userChoice;
  deferredPrompt = null;
};
